var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClarityEmployeeSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7088 11.2437C14.1864 11.2437 16.1949 9.23521 16.1949 6.7576C16.1949 4.27998 14.1864 2.27148 11.7088 2.27148C9.23116 2.27148 7.22266 4.27998 7.22266 6.7576C7.22266 9.23521 9.23116 11.2437 11.7088 11.2437Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.584 19.4453H19.4451V20.4175H14.584V19.4453Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4166 20.8335V22.9168C10.4166 23.101 10.4897 23.2776 10.62 23.4079C10.7502 23.5381 10.9268 23.6113 11.111 23.6113H22.9166C23.1007 23.6113 23.2774 23.5381 23.4076 23.4079C23.5379 23.2776 23.611 23.101 23.611 22.9168V15.9724C23.611 15.7882 23.5379 15.6116 23.4076 15.4813C23.2774 15.3511 23.1007 15.2779 22.9166 15.2779H18.0555V14.2571C18.0555 14.0729 17.9823 13.8963 17.8521 13.7661C17.7218 13.6358 17.5452 13.5627 17.361 13.5627C17.1768 13.5627 17.0002 13.6358 16.87 13.7661C16.7397 13.8963 16.6666 14.0729 16.6666 14.2571V15.2779H15.2777V12.7918C14.0977 12.5987 12.904 12.5012 11.7082 12.5002C9.07129 12.4889 6.46389 13.0555 4.06935 14.1599C3.67524 14.3459 3.34276 14.641 3.11135 15.0103C2.87994 15.3795 2.75931 15.8075 2.76379 16.2432V20.8335H10.4166ZM22.2221 22.2224H11.8055V16.6668H16.6666V16.9585C16.6666 17.1427 16.7397 17.3193 16.87 17.4495C17.0002 17.5798 17.1768 17.6529 17.361 17.6529C17.5452 17.6529 17.7218 17.5798 17.8521 17.4495C17.9823 17.3193 18.0555 17.1427 18.0555 16.9585V16.6668H22.2221V22.2224Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityEmployeeSolid);
export default __webpack_public_path__ + "static/media/clarity_employee-solid.03a857b587bd31be151e677ad851e230.svg";
export { ForwardRef as ReactComponent };